import { render, staticRenderFns } from "./District.vue?vue&type=template&id=c034a948&"
import script from "./District.vue?vue&type=script&lang=js&"
export * from "./District.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports